<template>
  <div class="loginbox">
    <div class="login">
      <div class="logo-group"></div>
      <div class="input-group">
        <div class="input-box border">
          <input v-model.trim="mp" type="number" class="tel" placeholder="手机号"  maxlength="11" @input="onlyNum">
          <span v-if="countDown" class="get-code">{{time}}s</span>
          <span v-else v-on:click="postSmsCaptcha" class="get-code">获取验证码</span>
        </div>
        <div class="input-box border">
          <input v-model.trim="captcha" type="number" placeholder="验证码" maxlength="25">
        </div>
      </div>
      <!--<p class="tips">如果您还没有用这个手机号注册过俺来也，我们将为您创建俺来也账号。</p>-->
      <span @click.stop="postSignIn" class="btn btn-main btn-lg btn-block">绑定手机号</span>
    </div>
  </div>
</template>

<script>
  import {actions} from '../store/actions'
  // import { MessageBox, Indicator} from 'mint-ui'

  export default {
    data () {
      return {
        graph_token: '',
        mp: '',
        captcha: '',
        countDown: false,
        time: 60,
      }
    },
    computed: {
      wxToken () {
        return this.$store.state.wxToken
      },
      schoolInfo () {
        return this.$store.state.schoolInfo
      }
    },
    mounted () {
      let _this = this
      /**
       * 如果有指定学校id
       */
      let url_school_id = _this.$utils.resolveUrl().school_id
      if (url_school_id) {
        actions.postSchoolStatus(_this, {school_id: url_school_id}, function (data) {
          let schoolInfo = {
            schoolId: data.school_id,
            schoolName: data.school_name
          }
          _this.$store.commit('changeSchoolInfo', schoolInfo)

        }, function () {
          _this.$messagebox.alert(data.body.message, '')
        })
      } else {
        if (_this.$store.state.schoolInfo && _this.$store.state.schoolInfo.schoolId) {

        } else {
          _this.$router.push({path: `/chooseschool`})
          return false
        }
      }
      this.addLog()
    },
    methods: {
      addLog() {
        // 内部统计
        var _this = this;
        var params = {
          logDetails: [{uid: _this.$store.state.wxUid, code: 'aly_wechat_login', createTime: new Date().getTime(), firstValue: this.$utils.getCookie('UM_distinctid')}]
        }
        actions.postLogAdd(_this, params, function (data) {
          console.log('记录成功');
        }, function (data) {

        })
      },
      onlyNum: function(){
        var _this = this
        var patt = _this.mp.replace(/[^\d]/g,'')
        if(_this.mp != patt){
          _this.mp = patt
          _this.$messagebox.alert('只能输入数字','')
        }
      },
      // 发送短信验证码
      postSmsCaptcha: function () {
        var _this = this
        if (_this.mp === '') {
          _this.$messagebox.alert('请输入手机号码','')
          return false
        }
        var phonereg = /^1[0-9]{10}$/;
        if (!phonereg.test(_this.mp)) {
          _this.$messagebox.alert('请输入正确格式的手机号', '')
          return false;
        }
        var params = {
          graph_token: _this.graph_token,
          mp: _this.mp,
          type: '101',
        }
        actions.postSendCaptcha(_this, params, function (data) {
          if(data.status==0){
            _this.$messagebox.alert('短信已发送成功!请注意查收','')
            _this.countDownFn()
          }else{
            _this.graph_token = data.graph_token;
            _this.showDrag = true;
            setTimeout(function(){
              _this.dialogClientX = document.getElementsByClassName('drag')[0].offsetLeft;
              _this.maxWidth = document.getElementsByClassName('drag_box')[0].offsetWidth - document.getElementsByClassName('handler')[0].offsetWidth;  //能滑动的最大间距
              document.getElementsByTagName('html')[0].addEventListener('touchmove', _this.mouseMoveFn);
              document.getElementsByTagName('html')[0].addEventListener('touchend', _this.mouseUpFn)
            }, 1000);

          }

        })
      },
      // 登录注册
      postSignIn: function () {
        var _this = this;
        if (_this.mp === '') {
          _this.$messagebox.alert('请输入手机号码','')
          return false
        }
        if (_this.captcha === '') {
          _this.$messagebox.alert('请输入短信验证码','')
          return false
        }

        var params = {
          school_id: _this.$store.state.schoolInfo.schoolId,
          captcha: _this.captcha,
          captcha_type: 101,
          mp: _this.mp,
          // token:'ef871ba5bce44fc0c36d37a389eab16f',
          token: _this.$store.state.wxToken,
          client_type: localStorage.getItem('platformType')
        }

        /**
         * 是否是单校区*/
        var school_lock = window.localStorage.getItem('school_lock')
        if (school_lock == '1') {
          params.ref = 'other_wechat'
        } else {
          params.ref = 'aly_wechat'
        }


        actions.postSignInIaaa(_this, params, function (data) {
          let openid = _this.$store.state.openId
          if(data.openid && data.openid!=''){
            openid = data.openid
          }

          let userInfo = {
            avatar: data.avatar || data.headimgurl,
            nickname: data.nickname,
            mp: data.mp,
            sex: data.sex
          }


          _this.$store.commit('changeUserInfo', userInfo)

          var obj = {
            wxUid: data.uid,
            wxToken: data.token,
            openId: openid,
            wxLoginToken: data.login_token,
            platformType: data.platform_type
          };
          _this.$store.commit('changeState', obj);
          window.localStorage.removeItem('selfTakeMp');
          _this.$router.push({name: 'TagPage'});
        })
      },
      // 60s倒计时方法
      countDownFn: function () {
        var _this = this
        _this.time = 60
        function setTime () {
          if (_this.time === 0) {
            _this.countDown = false
            return false
          } else {
            _this.countDown = true
            _this.time--
          }
          setTimeout(function () {
            setTime()
          }, 1000)
        }
        setTime()
      }
    }
  }
</script>





// WEBPACK FOOTER //
// BindPhone.vue?275d349c